import { useState } from "react";
import { Input } from "shared/ui/Input";
import { Button } from "shared/ui/button";
import { useHttpRequest } from "shared/lib/hooks/useHttpRequest";
import { forgotPasswordRequest } from "features/login/api/forgotPasswordRequest";
import { getEmailErrorMessage } from "features/login/lib/register-validation/emailValidation";
import styles from "../FormStyles.module.scss";

export const EmailEnterForm = ({ onPasswordReset }) => {
  const { sendRequest, loading, error, clearError } = useHttpRequest(
    forgotPasswordRequest,
  );

  const [formData, setFormData] = useState({
    email: "",
  });

  const [fieldErrors, setFieldErrors] = useState({
    email: false,
  });

  const [errorMessages, setErrorMessages] = useState({
    email: "",
  });

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));

    if (value.trim() !== "") {
      setFieldErrors((prev) => ({ ...prev, [field]: false }));
      setErrorMessages((prev) => ({ ...prev, [field]: "" }));
    }
  };

  const handleBlur = (field, value) => {
    if (field === "email") {
      const errorMessage = getEmailErrorMessage(value);
      setErrorMessages((prev) => ({ ...prev, email: errorMessage || "" }));
      setFieldErrors((prev) => ({ ...prev, email: !!errorMessage }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const emailError = getEmailErrorMessage(formData.email);

    setFieldErrors({
      email: !!emailError,
    });

    setErrorMessages({
      email: emailError || "",
    });

    if (emailError || loading) return;

    const submitData = {
      email: formData.email.trim(),
    };

    try {
      await sendRequest(submitData);
      onPasswordReset?.(formData.email.trim());
    } catch (error) {
      const status = error?.status;

      if (status === 401) {
        return;
      }

      if (status >= 500) {
        return;
      }
    }
  };

  return (
    <div className={styles.formWrapper}>
      <div className={styles.formWrapper__topBlock}>
        <p className={styles.formWrapper__title}>Сброс пароля</p>
        <p className={styles.formWrapper__text}>
          Введите адрес электронной почты к которой привязан ваш аккаунт. Мы
          отправим на него 6-значный код для сброса пароля.
        </p>
      </div>
      <div className={styles.formWrapper__form}>
        <div className={styles.formWrapper__formItem}>
          <p className={styles.formWrapper__label}>Электронная почта</p>
          <Input
            type="text"
            value={formData.email}
            onChange={(e) => handleInputChange("email", e.target.value)}
            onBlur={(e) => handleBlur("email", e.target.value)}
            placeholder="Введите почтовый адрес"
            className={`${styles.formWrapper__input} ${fieldErrors.email ? styles.formWrapper__fieldError : ""}`}
          />
          {errorMessages.email && (
            <span className={styles.formWrapper__errorText}>
              {errorMessages.email}
            </span>
          )}
        </div>
        {!errorMessages.email && fieldErrors.email && (
          <span className={styles.formWrapper__greenText}>
            Не заполнено обязательное поле
          </span>
        )}

        {error && (
          <span className={styles.formWrapper__greenText}>
            Произошла ошибка, попробуйте позже
          </span>
        )}
      </div>
      <div className={styles.formWrapper__buttonBlock}>
        <div className={styles.formWrapper__button}>
          <Button variant="primary" size="large" onClick={handleSubmit}>
            Отправить код
          </Button>
        </div>
      </div>
    </div>
  );
};
